import { render } from "./Mathematical.vue?vue&type=template&id=02728510&scoped=true"
import script from "./Mathematical.vue?vue&type=script&lang=js"
export * from "./Mathematical.vue?vue&type=script&lang=js"

import "./Mathematical.vue?vue&type=style&index=0&id=02728510&lang=scss&scoped=true"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02728510"]])

export default __exports__